import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import SwiperCore, { Pagination, EffectFade, Autoplay } from 'swiper/core';

// Enable Swiper Paginate, Fade Effect and Autoplay

SwiperCore.use([Pagination, EffectFade, Autoplay]);

@Component({
    selector: 'app-pb-reading-resources-summary',
    templateUrl: './pb-reading-resources-summary.component.html',
    styleUrls: ['./pb-reading-resources-summary.component.scss']
})
export class PbReadingResourcesSummaryComponent implements OnInit {

    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    posts: any = [];
    loadedPosts: boolean = false;

    // A swiper config which is responsive and doesn't show partial slides

    public responsiveNoOverflowConfig: any = {
        slidesPerView: 1,
        spaceBetween: 15,
        freeMode: true,
        watchOverflow: true, // Automatically hides pagination when not needed
        pagination: { clickable: true },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
        }
    };

    constructor(private api: ApiService, private cd: ChangeDetectorRef) { }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchPosts();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding === 'SMALL') {
            return '10';
        } else if (padding === 'MEDIUM') {
            return '15';
        } else if (padding === 'LARGE') {
            return '30';
        } else if (padding === 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetches notice board posts
     */
    async fetchPosts() {

        await this.api.fetch_posts()
            .subscribe(res => {
                this.posts = res.data.items;
                this.posts = this.posts.slice(0, 3);

                this.posts.forEach(element => {
                    let tags = [];

                    element.tagged.forEach(subelement => {
                        tags.push(subelement.tag_name);
                    });

                    if (tags.length > 0) {
                        element.tag = tags[0]
                    } else {
                        element.tag = '';
                    }
                });

                this.loadedPosts = true;
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * When 'Reading and resources' swiper is ready then run the update so that the slide size is correct
     * @param swiper 
     */
    onResourcesSwiper(swiper) {

        setTimeout(() => {
            // swiper.update();
        }, 1500);

    }

}
